import Cookies from 'js-cookie';
import { PORTAL_ACCESS_TOKEN_KEY, PORTAL_REFRESH_TOKEN_KEY } from 'constants/index';
import SpaceService from 'modules/security/spaces/services/Space.service';
import { useNavigate } from 'react-router-dom';
import { useAuth, useSecurity } from '@dfl/react-security';
import { useEffect, useMemo } from 'react';

export const useAuthFromPortal = () => {
  const { isAuthenticated } = useSecurity();
  const accessToken = useMemo(() => Cookies.get(PORTAL_ACCESS_TOKEN_KEY), []);
  const refreshToken = useMemo(() => Cookies.get(PORTAL_REFRESH_TOKEN_KEY), []);
  const navigate = useNavigate();
  const { setAuth } = useAuth();

  useEffect(() => {
    if (!isAuthenticated && accessToken && refreshToken) {
      const at = accessToken;
      const rt = refreshToken;
      Cookies.remove(PORTAL_ACCESS_TOKEN_KEY, {
        domain: process.env.REACT_APP_PORTAL_BASE_DOMAIN || 'negocioscuba.net',
      });
      Cookies.remove(PORTAL_REFRESH_TOKEN_KEY, {
        domain: process.env.REACT_APP_PORTAL_BASE_DOMAIN || 'negocioscuba.net',
      });
      setTimeout(() => {
        SpaceService.changeSpaceToken('PUBLIC', at, rt, true)
          .then((data: any) => {
            setAuth({ ...data?.data });
            navigate('/');
          })
          .catch((err: any) => {
            if (err.status === 403 || err.statusCode === 403) {
              navigate('/auth/login');
            }
          });
      }, 300);
    } else if (isAuthenticated && accessToken && refreshToken) {
      Cookies.remove(PORTAL_ACCESS_TOKEN_KEY, {
        domain: process.env.REACT_APP_PORTAL_BASE_DOMAIN || 'negocioscuba.net',
      });
      Cookies.remove(PORTAL_REFRESH_TOKEN_KEY, {
        domain: process.env.REACT_APP_PORTAL_BASE_DOMAIN || 'negocioscuba.net',
      });
    }
  }, [accessToken, refreshToken, isAuthenticated, navigate, setAuth]);

  return { accessToken, refreshToken };
};
